export default __webpack_public_path__ + "static/media/logo-transp-noir.bd53f989.png";